import React, {useState, useContext} from 'react';
import {ViewContext} from './contexts/ViewContext';

import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logo from './img/route4u-hive.png';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {Button} from '@material-ui/core';
import {cities} from './utils/Constants';

const useStyles = makeStyles((theme) => ({
	grow: {
		flexGrow: 1,
	},
	sectionRight: {
		display: 'flex',
	},
	logo: {height: '32px', margin: '16px'},
	appBar: {
		backgroundColor: 'white',
		zIndex: theme.zIndex.drawer - 1,
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
	button: {
		textTransform: 'none',
		fontWeight: 400,
		color: '#777777',
		borderRadius: 0,
		marginLeft: theme.spacing(2),
	},
	buttonSelected: {
		borderBottom: '2px solid blue',
		color: '#000000',
	},
}));

export default function Header() {
	const {view, dispatch} = useContext(ViewContext);

	const classes = useStyles();

	const handleChange = () => {};

	return (
		<AppBar position="fixed" className={classes.appBar} color="transparent">
			<Toolbar>
				<img className={classes.logo} src={logo} alt="Logo" />
				<FormControl className={classes.formControl}>
					<Select
						disableUnderline
						value={view.selectedCity}
						onChange={(evt) => dispatch({type: 'CHANGE CITY', city: evt.target.value})}
						displayEmpty
						inputProps={{'aria-label': 'Without label'}}
					>
						{cities.map((city) => (
							<MenuItem key={city.name} value={city.name}>
								{city.name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<Button
					className={classes.button + (view.selectedView == 'Dashboard' ? ' ' + classes.buttonSelected : '')}
					onClick={() => dispatch({type: 'CHANGE VIEW', view: 'Dashboard'})}
				>
					Dashboard
				</Button>
				<Button
					className={classes.button + (view.selectedView == 'Map' ? ' ' + classes.buttonSelected : '')}
					onClick={() => dispatch({type: 'CHANGE VIEW', view: 'Map'})}
				>
					Map
				</Button>
				<div className={classes.grow} />
				<div className={classes.sectionRight}></div>
			</Toolbar>
		</AppBar>
	);
}
